import { render, staticRenderFns } from "./profileCard.vue?vue&type=template&id=e5f81cb2&scoped=true&lang=html&"
import script from "./profileCard.vue?vue&type=script&lang=js&"
export * from "./profileCard.vue?vue&type=script&lang=js&"
import style0 from "./profileCard.vue?vue&type=style&index=0&id=e5f81cb2&lang=scss&scoped=true&"
import style1 from "./profileCard.vue?vue&type=style&index=1&id=e5f81cb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f81cb2",
  null
  
)

export default component.exports